import { render } from "./UserPresensi.vue?vue&type=template&id=74f25f0a"
import script from "./UserPresensi.vue?vue&type=script&lang=js"
export * from "./UserPresensi.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__